// extracted by mini-css-extract-plugin
export default {"remove":"LEYW3ErQ87ucSOHTz1hr","shrink":"M7lO69AYZTIl5PHVSeiM","hiddenSmall":"Yvk6gQOpLKQzVHMDseIL","justIcon":"GE_YF1D4oyp4cWNFUqvw","pulse":"oO7vOFndvmeUuoKDspfR"};